/**
 * @generated SignedSource<<a1e4fb1d5ba03c8987a2b3b21db91c47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimezoneSelector_viewer$data = {
  readonly supportedTimezones: ReadonlyArray<{
    readonly description: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "TimezoneSelector_viewer";
};
export type TimezoneSelector_viewer$key = {
  readonly " $data"?: TimezoneSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimezoneSelector_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimezoneSelector_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeZone",
      "kind": "LinkedField",
      "name": "supportedTimezones",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "be720adf73651b207edd9e7d26d706e3";

export default node;
